export enum GenericUploadFileFormat {
  Csv = "Csv",
  Excel = "Excel",
}
